var UitkCarouselBreakPointSizeMap = [
    ['sm', 'sm'],
    ['md', 'md'],
    ['lg', 'lg'],
    ['xl', 'xl']
];
var UitkCarouselBreakPointSizes = new Map(UitkCarouselBreakPointSizeMap);
var UitkHeadingTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6']
];
var UitkHeadingTags = new Map(UitkHeadingTagMap);

export { UitkCarouselBreakPointSizes, UitkHeadingTags };
